var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 25,
    viewBox: "0 0 74 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6768 18.6138C73.5681 18.2401 73.9876 17.2145 73.6138 16.3232L67.5229 1.79867C67.1491 0.907367 66.1236 0.487826 65.2323 0.861597C64.341 1.23537 63.9214 2.26091 64.2952 3.15221L69.7094 16.0629L56.7987 21.4771C55.9074 21.8509 55.4878 22.8764 55.8616 23.7677C56.2354 24.659 57.2609 25.0786 58.1522 24.7048L72.6768 18.6138ZM1.30223 15.3951C0.415883 15.7805 0.00975931 16.8114 0.395127 17.6978C0.780496 18.5841 1.81142 18.9902 2.69777 18.6049L1.30223 15.3951ZM72.6626 15.3803C61.5857 10.8488 50.8369 7.25 37 7.25V10.75C50.1631 10.75 60.4143 14.1512 71.3374 18.6197L72.6626 15.3803ZM37 7.25C23.1842 7.25 12.9403 10.3351 1.30223 15.3951L2.69777 18.6049C14.0597 13.6649 23.8158 10.75 37 10.75V7.25Z",
    fill: "#6F7FE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowIcon);
export default __webpack_public_path__ + "static/media/nav-arrow-icon.cebbbf18f2c6089c0d375d1e648524f9.svg";
export { ForwardRef as ReactComponent };